

const ImageDimensions = [
    {
        height                                : 800,
	
        width                                 : 800,
        

    },


];

export { ImageDimensions };